/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

export const getShortId = (id?: string): string | undefined => {
	if (typeof id !== "string") return undefined;
	if (id.length <= 6) return id;
	return id.substring(id.length - 6);
};

export const cleanHashId = (id?: string): string =>
	id
		?.trim()
		.replace(/\s+/g, "-")
		.replace(/[^\w0-9-+.]/g, "")
		.toLowerCase() || "";

export const getFaqId = (id?: string, prefix = "faq-"): string => `${prefix}${cleanHashId(id) || "noid"}`;
